import * as React from 'react';
import customSolarIconWrapper from '../../../custom-icons';

// Placed on the shared 240x240 doodle frame: stack a body, eyes, mouth and accessory to compose a doodle
const DoodleAccessoryDodo = customSolarIconWrapper(<g transform="translate(165 35)">
	<path d="M0 32.6178V27.7124L14.9709 7.1351H0.0617981V0H25.9207V4.90541L10.9498 25.4826H25.8588V32.6178H0Z" fill="#202020" />
	<path d="M29.6103 34.5388L29.1553 31.5158L36.4733 17.4526L27.286 18.8295L26.6245 14.4325L42.5603 12.0444L43.0143 15.0674L35.6973 29.1306L44.8843 27.7537L45.5463 32.1507L29.6103 34.5388Z" fill="#202020" />
	<path d="M43.2314 41.6265L44.2014 38.7271L57.1194 29.5131L48.3074 26.5765L49.7184 22.3591L65.0024 27.4524L64.0324 30.3519L51.1144 39.5658L59.9274 42.5024L58.5164 46.7198L43.2314 41.6265Z" fill="#202020" />
</g>, { viewBox: '0 0 240 240' });

export default DoodleAccessoryDodo;
